import React, { type FunctionComponent } from 'react'
import { useHideNavbarDueToPendingOnboarding } from '@retailer-platform/domain-onboarding'
import WarehouseProvider from '../../../../utils/contexts/warehouse/WarehouseProvider'
import ErrorBoundary from '../../../../legacy/components/ErrorBoundary'
import { RetailerNav } from '../../../../gin-and-tonic/containers/nav/RetailerNav'
import { AppContentContainer } from '../../../../gin-and-tonic/containers/app-content-container/AppContentContainer'
import { useAdminControls } from '../../../../utils/contexts/admin-controls/AdminControlsContext'
import { LeftShortcutsPaneRetailer } from '../../../../gin-and-tonic/containers/nav-v2/components/LeftShortcutsPane/LeftShortcutsPaneRetailer'
import { MenuBarTop } from '../../../../gin-and-tonic/containers/nav-v2/components/MenuBarTop'
import { useNavHierarchyRetailer } from '../../../../gin-and-tonic/containers/nav-v2/NavMenuHierarchy'
import { useWindowSizeIsWide } from '../../../../utils/window/windows.hooks'
import { ContactHeader } from '../../../utils/ContactHeader'
import { useRequiredNavDataLoadingStatus } from '../../../../gin-and-tonic/containers/nav/utils/nav.hooks'
import { DASH_NAV_V2_HEIGHT, DASH_NAV_WIDTH } from '../../../../legacy/common/theme'
import { useNavContext } from '../../../../gin-and-tonic/containers/nav/utils/NavContext'
import { RetailerScopedRoutes } from './RetailerScopedRoutes'
import { useNavV2Visibility } from './retailerScoped.hooks'

interface Props {
  warehouseId: string
  pathname: string
}

export const RetailerScopedSectionNav: FunctionComponent<Props> = ({ warehouseId, pathname }) => {
  const hideNavBar = useHideNavbarDueToPendingOnboarding()
  const { showContactHeader } = useAdminControls()
  const isWide = useWindowSizeIsWide()
  useNavV2Visibility()
  const { navV2Enabled: useNavV2 } = useNavContext()

  const { navMenuHierarchy } = useNavHierarchyRetailer()

  const { loading, error } = useRequiredNavDataLoadingStatus()
  if (loading || error) return null

  const topPadding = useNavV2 ? DASH_NAV_V2_HEIGHT : '0px'
  const leftPadding = useNavV2 ? '0px' : DASH_NAV_WIDTH

  return (
    <>
      {!hideNavBar && !useNavV2 && <RetailerNav />}
      {!hideNavBar && useNavV2 && <MenuBarTop navMenuHierarchy={navMenuHierarchy} />}
      <div
        css={{
          display: 'flex',

          // this CSS is a relic of the Nav V1 implementation. If we don't position absolute left: 0
          // the content is shifted off screen to the left.
          position: 'absolute',
          left: leftPadding,
          top: topPadding,

          width: `calc(100% - ${leftPadding})`,
          minHeight: `calc(100% - ${topPadding})`,
          height: `calc(100% - ${topPadding})`,
        }}
      >
        {!hideNavBar && isWide && useNavV2 && <LeftShortcutsPaneRetailer />}
        <WarehouseProvider id={warehouseId}>
          <AppContentContainer>
            {/* Totem does not have a proper staging/dev environment. Totem prod api is not accessible to mesh outside of prod */}
            {showContactHeader && <ContactHeader />}
            <ErrorBoundary pathname={pathname}>
              <RetailerScopedRoutes />
            </ErrorBoundary>
          </AppContentContainer>
        </WarehouseProvider>
      </div>
    </>
  )
}
